import React, { useState, useEffect } from 'react';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { translate, showMessageToastCustom, stringFormat, newObj, getNumberValueOrDefault } from '../../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import { Input } from '../../../../components/UI/ComponentsUI';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';

const ModalCimPalletQuantity = (props) => {
    const [model, setModel] = useState({});
    const [messageConfirmationBoxesQuantity, setMessageConfirmationBoxesQuantity] = useState('')
    const [openModalConfirmation, setOpenModalConfirmation] = useState(false)

    useEffect(() => {
        if (props.receipt) {
            let newModel = newObj(props.receipt);
            newModel.qtStorage = calcBalance(props.receipt);
            newModel.pallets = 1;
            setModel({ ...newModel });
        }
    }, [props.receipt]);

    const onChangeBoxQuantity = (event) => {

        if (getNumberValueOrDefault(event.target.value) > 0) {
            var piecePerBox = parseInt(getNumberValueOrDefault(props.receipt.balance) / getNumberValueOrDefault(event.target.value))
            model.qme = piecePerBox
        }

        onValueChange(event, model, setModel);
    };

    const validateInsert = () => {
        if (props.onConfirm && validateInputsRequired("formInput")) {
            if (model.balance < ((model.qtStorage * model.qme) * model.pallets)) {
                showMessageToastCustom(translate('warning', 'general'), `Valor informado maior do que o disponivel - ${model.balance}`, 8000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                if (model.qtStorage > 1 && Number(model.qme) === 1) {
                    setOpenModalConfirmation(true)
                    setMessageConfirmationBoxesQuantity(stringFormat(translate('receiptMultipleBoxes1PrintConfirmation', 'physical-confirmation'), model.qtStorage))
                }
                else if (model.qtStorage >= 50) {
                    setOpenModalConfirmation(true)
                    setMessageConfirmationBoxesQuantity(stringFormat(translate('generating50OrMorePrintsConfirmation', 'physical-confirmation'), model.qtStorage))
                }
                else {
                    onConfirm()
                }
            }
        }
    }



    const onConfirm = () => {
        if (model.remainingBalance) {

            if (props.truckKanban) {
                let newModel = {};
                Object.assign(newModel, props.receipt);
                // Marca o primeiro como falso;
                newModel.qtStorage = model.qtStorage;
                newModel.qme = props.receipt.balance
                props.onConfirm(newModel);
                return close();
            }
            else {
                var remainingQuantity = props.receipt.balance - (model.qtStorage * model.qme * model.pallets);
                if (remainingQuantity > 0) {
                    let newModel = {};
                    Object.assign(newModel, props.receipt);
                    // Marca o primeiro como falso;
                    model.remainingBalance = false;
                    //Cria um novo informando que é restante do material para o mesmo pallet
                    newModel.remainingBalance = true;
                    newModel.qtStorage = 1;
                    newModel.pallets = 1;
                    newModel.qme = remainingQuantity;
                    newModel.mdr = model.mdr;
                    props.onConfirm(newModel);
                }
            }
        }
        props.onConfirm(model);
        close();
    }

    const calcBalance = (value) => {
        if (value.balance) {
            return parseInt(value.balance / (value.qme > 0 ? value.qme : 1) || 1)
        }

        return "";
    }

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onCancel = (event) => {
        if (props.onCancel) {
            props.onCancel(event);
        }
        close();
    };

    const close = () => {
        setModel({});
        if (props.onClose) {
            props.onClose();
        }
    };

    const validadeRemainingBalance = () => {
        var balance = getNumberValueOrDefault(props.receipt.balance)
        var qtdStorage = getNumberValueOrDefault(model.qtStorage)
        var qme = getNumberValueOrDefault(model.qme)
        var pallets = getNumberValueOrDefault(model.pallets)

        var remainingQuantity = balance - (qtdStorage * qme * pallets);
        return remainingQuantity;
    }

    return (
        <>
            <ConfirmModalUI
                open={openModalConfirmation}
                id="messageAlert"
                data={{
                    title: `${translate('validations:attention')} ${translate('confirm', 'general')}`,
                    message:
                        <span className="title col s12" style={{ color: 'red' }}>
                            {messageConfirmationBoxesQuantity}
                        </span>
                }}
                onConfirm={() => {
                    setOpenModalConfirmation(false);
                    onConfirm()
                }}
                onCancel={() => setOpenModalConfirmation(false)}
                onClose={() => setOpenModalConfirmation(false)}
                showCancel={true}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')} />
            <Modal
                open={props.open}
                options={{ dismissible: false }}
                id={props.id || 'ModalReceiptQuantity'}
                actions={
                    <Row className="center" style={{ height: "60%" }}>
                        <Button onClick={onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                            {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                        </Button>
                        <ButtonUI onClick={
                            validateInsert
                        } text={props.btnConfirm ? props.btnConfirm : translate('add', 'general')} />
                    </Row>
                }
            >
                <div>
                    {
                        props.open &&
                        <>
                            <Row className="center">
                                <div className="sixth-text-color center">
                                    <span className="title col s12">{props.title}</span>
                                    <span className="col s12" >{props.content}</span>
                                </div>
                            </Row>
                            <div>
                                <span className="field sixth-text-color f-1p5r" style={{ marginBottom: 0 }}>{translate('physical-confirmation:almox')}: {model.almox}</span>
                            </div>
                            <div id="formInput" className='row'>
                                <div className="input-field no-padding col s12">
                                    {/* Numero de Etiquetas que será geradas*/}
                                    <Input
                                        required
                                        id="qtStorage"
                                        name="qtStorage"
                                        label={translate('physical-confirmation:qt-volume')}
                                        onChange={onChangeBoxQuantity}
                                        value={model?.qtStorage}
                                        step="1"
                                    />

                                </div>
                                <div className="input-field no-padding col s12">
                                    {/* Numero de items por etiqueta*/}
                                    <Input
                                        required
                                        id="qme"
                                        name="qme"
                                        label={translate('physical-confirmation:partnumber')}
                                        value={model?.qme}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        required
                                        id="mdr"
                                        name="mdr"
                                        label="MDR"
                                        defaultValue={model?.mdr}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        type="number"
                                        required
                                        id="pallets"
                                        name="pallets"
                                        label="Pallets"
                                        defaultValue={model?.pallets}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col s12" style={{ padding: '0px', color: 'red', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <label className="field f-1p5r truncate col s12" style={{ color: 'red' }} htmlFor="remainingQuantity">{translate('physical-confirmation:remainingQuantity')}: {validadeRemainingBalance()}</label>
                                </div>
                                {
                                    validadeRemainingBalance() > 0 &&
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="remainingBalance"
                                            name="remainingBalance"
                                            type="checkbox"
                                            label={translate('physical-confirmation:remainingBalance')}
                                            onChange={onChange}
                                            defaultChecked={model?.remainingBalance}
                                        />
                                    </div>
                                }
                            </div>
                            {
                                getNumberValueOrDefault(model?.qtStorage) === "1" &&
                                <div className="col s12" style={{ padding: '0px', color: 'red' }}>
                                    {translate("physical-confirmation:no-cim-pallet-master")}
                                </div>
                            }
                        </>
                    }
                </div>
            </Modal >
        </>
    );
};

export default ModalCimPalletQuantity;